import { getTimezoneOffset, utcToZonedTime, format } from "date-fns-tz";
import { DateTime } from "luxon";

function timezoneToParsedOffset(tz: string, date?: Date) {
  const offsetInMs = getTimezoneOffset(tz, date);
  const offsetInMinutes = Math.abs(offsetInMs/(60*1000));
  const offsetInHours = Math.floor(offsetInMinutes/60);

  return {
    hours: offsetInHours,
    minutes: (offsetInMinutes-(60*offsetInHours)),
    sign: offsetInMs > 0 ? '+' : '-',
  }
}



function formatUTCToLocalTime(utcDate: Date, ianaTimeZone: string, fmt = "dd/MM/yyyy HH\':\'mm"): string {
  // Parse the UTC date string and set it to UTC
  const dt = DateTime.fromISO(utcDate.toISOString()).setZone('utc');

  // Convert to the local time zone
  const localTime = dt.setZone(ianaTimeZone);

  // Format the date
  const formattedDate = localTime.toFormat(fmt);

  return formattedDate;
}

export {
  timezoneToParsedOffset,
  formatUTCToLocalTime,
}